import React from "react";
import { StateManagerContext } from "./StateManagerContext";
import { Post, PostDisplayProps } from "./Post";
import { PostConfigData } from "../Shared/Party/PartyConfigData";
import { UIConfigContext } from "./UIConfigContext";
import { FanboxColorPalette } from "../Shared/Utility/Color";
import { ActionHandler } from "./ActionButton";
import { ActionSharePanel, ActionSharePanelProps } from "./ActionSharePanel";
import { UserAction, UserActionStatus } from "../Shared/UserData";
import { release } from "os";


/*export type UserActionDisplayProps = {
    width: number;
    height: number;
    absolute: boolean;
    top?: number,
    left?: number,
    background: string;
    fontBase: number;
    showSignIn(): void;
}*/

type UserActionDisplayState = 'list' | 'share';

const convertActionStatusToNumber = (status: UserActionStatus) : number => {
    switch (status) {
        case 'live':
            return 3;
        case 'moderating':
            return 2;
        case 'scheduled':
            return 2;
        case 'ready':
            return 1;
        case 'pending':
            return 0;
    }
}

export const UserActionDisplay = (): JSX.Element => {
    const stateManager = React.useContext(StateManagerContext);
    const uiConfig = React.useContext(UIConfigContext);
    const actions = stateManager.user().actions;
    const [displayState, setDisplayState] = React.useState<UserActionDisplayState>('list');
    const displayActions = React.useRef<UserAction[]>([]);
    const selectedAction = React.useRef<number>(-1);

    var components: JSX.Element[] = [];

    if (displayState === 'list') {

        displayActions.current.splice(0);
        displayActions.current.push(...actions);
        displayActions.current.sort((a, b) => {
            const statusDiff = convertActionStatusToNumber(a.status) - convertActionStatusToNumber(b.status);
            if(statusDiff === 0){
                return a.created - b.created;
            }
            else
                return statusDiff;
        })

        components = displayActions.current.map((action, index) => {

            const postConfig: PostConfigData = {
                itemId: action.itemId,
                title: action.title,
                author: '@Fanbox',
                layout: 'single-element',
                rotate: 'none',
                messageDisplay: 'none',
                elements: [{
                    itemId: action + '_e0',
                    layout: 'primary-left',
                    primary: {
                        text: action.bodyText,
                        buttonColor: 'blue',
                        buttonText: action.status === 'ready' ? action.buttonText : action.statusText,
                        buttonClick: 'opt:none'
                    },
                    secondary: {
                        imageSrc: action.image
                    }
                }]

            }

            const handler: ActionHandler = action.status === 'ready' ? (_actionData) => {
                console.log('User Action Share Button Clicked - index= ' + index + ' id= ' + action.itemId);
                selectedAction.current = index;
                setDisplayState('share');
                return true;
            } : (_actionData) => { return true; }

            const postDisplay: PostDisplayProps = {
                postHeight: 400,
                messageHeight: 0,
                userId: stateManager.user().fanbox.id,
                showLikeCommentButtons: false,
                actionHandler: handler
            }


            return <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: uiConfig.contolBackground, justifyContent: 'right' }}>
                <Post display={postDisplay} config={postConfig} />
                {/*<div style={{
                                width: "186px",
                                minWidth: "186px",
                                maxWidth: "186px",
                                height: "53px",
                                minHeight: "53px",
                                maxHeight: "53px",
                                borderRadius: "75px",
                                backgroundColor: "#1877F2",
                                lineHeight: "53px",
                                fontSize: "18px",
                                fontWeight: 700,
                                textAlign: "center",
                                color: "white",
                                margin : '20px'
                                
                              }}>Share</div>*/}
            </div>
        })

        if (components.length === 0) {
            components.push(<span style={{ fontFamily: 'roboto', fontWeight: 500, fontSize: (2 * uiConfig.fontBase) + 'px' }}>There are currently no actions to display</span>);
        }
    }
    else {
        const onFinish = () => {
            //const actionId = actions[selectedAction.current].itemId;
            //actions.splice(selectedAction.current, 1);
            selectedAction.current = -1;
            setDisplayState('list');
        };

        const onQuit = () => {
            setDisplayState('list');
        }
        const props: ActionSharePanelProps = {
            action: displayActions.current[selectedAction.current],
            height: uiConfig.height - uiConfig.titleHeight,
            onFinish: onFinish,
            onQuit: onQuit,
        }
        components.push(<ActionSharePanel {...props} />);
    }



    return <div style={{
        width: uiConfig.width + 'px',
        minWidth: uiConfig.width + 'px',
        maxWidth: uiConfig.width + 'px',
        height: (uiConfig.height - uiConfig.titleHeight) + 'px',
        maxHeight: (uiConfig.height - uiConfig.titleHeight) + 'px',
        minHeight: (uiConfig.height - uiConfig.titleHeight) + 'px',
        backgroundColor: uiConfig.fanboxColor('darkGray'),
        overflow: 'auto'
    }}>
        <div style={{
            width: uiConfig.width + 'px',
            minWidth: uiConfig.width + 'px',
            maxWidth: uiConfig.width + 'px'
        }}>
            {components}
        </div>
    </div>
}
